import React from 'react'
import { Stack } from '@mui/material'
import { useGlobalState } from 'state'
import { Legend } from 'common/types'


const LegendPanel = ({legend}: {legend: Legend}) => {
  return (
    <Stack alignItems={'flex-end'} mb={2}>
      {
        legend.title &&
          <Stack sx={{
            fontSize: 11,
            lineHeight: 1.3,
            textAlign: 'right',
            fontWeight: 'bold',
            whiteSpace: 'pre-wrap',
            textShadow: '1px 1px 0 #ffffff, -1px 1px 0 #ffffff, 1px -1px 0 #ffffff, -1px -1px 0 #ffffff',
            mb: '3px'
          }}>
            {legend.title}
          </Stack>
      }
      <Stack direction={'column'}>
        {
          legend.colors !== undefined && legend.colors.map((c, index) => {
            return (
              <Stack key={index} height={18} alignItems={'center'}
                sx={{
                  fontSize: 11,
                  px: 1,
                  backgroundColor: c.color,
                  color: '#ffffff',
                  textShadow: '1px 1px 1px rgba(30, 30, 30, 1), 1px 1px 2px rgba(30, 30, 30, 0.8), -1px 0px 1px rgba(30, 30, 30, 0.6)',
                  fontWeight: 'bold'
                }}>
                {c.value}
              </Stack>
            )
          })
        }
        {
          legend.image !== undefined && (
            <img src={legend.image} height={30} />
          )
        }
      </Stack>
    </Stack>
  )
}

export const LegendControl = () => {
  const state = useGlobalState()

  return (
    <Stack direction={'column'} alignItems={'flex-end'}>
      {
        state.app.hazardMapLegends.map((legend: Legend, index: number) => {
          return <LegendPanel legend={legend} key={index} />
        })
      }
    </Stack>
  )
}
